<script setup>
import Content from "@/components/Content/Content.vue";
import { LazyImg, Waterfall } from 'vue-waterfall-plugin-next'
import {computed, ref, onMounted} from "vue";


const props = defineProps({
	companyCulture: {
		type: Array,
		default: () => []
	}
})

const loadNum = ref(0)
const showPictureCard = ref(false)

const waterfallGutter = ref(20)
const waterfallRef = ref(null)

const albumFormat = computed(() => props.companyCulture.map(item => ({ src: item.image })))

const handleLoadImg = (e) => {
	const len = albumFormat.value.length
	++loadNum.value
	
	if (loadNum.value === len) {
		showPictureCard.value = true
		waterfallRef.value?.renderer()
	}
}


onMounted(() => {
	waterfallRef.value?.renderer()
})
</script>

<template>
	<div class="company-culture">
		<div class="company-culture__content">
			<Content
				:title="$t('section.culture')"
				mode="dark"
			>
				
				<div
					class="company-culture__content__picture"
					:style="{
						display: showPictureCard ? '' : 'none'
					}"
				>
					<Waterfall
						:list="albumFormat"
						:width="345"
						style="background-color:transparent;"
						:breakpoints="{
							1200: { rowPerView: 4 },
							800: { rowPerView: 2 },
							500: { rowPerView: 2 }
						}"
						:gutter="waterfallGutter"
						:hasAroundGutter="false"
						ref="waterfallRef"
					>
						<template #default="{ item, url }">
							<div class="image__card">
								<img
									:src="url"
									style="width: 100%; height: auto;object-fit: cover;"
									@load="handleLoadImg"
								/>
							</div>
						</template>
					</Waterfall>
				</div>
				
			</Content>
		</div>
	</div>
</template>

<style scoped lang="less">
.company-culture {
	background-image: url("~@/assets/images/bg/company-culture.png");
	background-size: contain;
	background-repeat: no-repeat;
	//background-position: center;
	
	&__content {
		padding: 72px 0;
		
		.image__card {
			padding: 10px;
			background-color: #fff;
			box-shadow: 0 5px 5px rgba(0, 0, 0, .2);
		}
		
	}
	
}

@media only screen and (max-width: 768px) {
	.company-culture {
		
		&__content {
			padding: 30px 0;
			
			.image__card {
				padding: 5px;
			}
		}
		
	}
}
</style>